module.exports = __webpack_public_path__ + "img/step-library-en.ac7c9ab4.webp";